import type { AccountUpdateInput } from '@gql/graphql';
import type { MtSettingsBreederPageFormValues } from '@presentation/pages';
import cleanDeep from 'clean-deep';
import { useCallback } from 'react';

export const useProfileUpdateBuilder = () => {
  const profileUpdateBuilder = useCallback((values: Partial<MtSettingsBreederPageFormValues>) => {
    const data: AccountUpdateInput = {
      ...cleanDeep(
        {
          language: { set: values.language },
          contactPreferences: values.contactPreferences,
        },
        { nullValues: false },
      ),
    };

    return { data };
  }, []);

  return { profileUpdateBuilder };
};
